import { render } from "./SetCard.vue?vue&type=template&id=9002b6e0"
import script from "./SetCard.vue?vue&type=script&lang=js"
export * from "./SetCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__